import { useTranslation } from 'react-i18next';
import { type ClientSession } from '@/types/Auth.ts';
import { SessionCountry } from './SessionCountry';
import { useSessionFormatters } from './useSessionFormatters';

interface SessionMetaProps {
  id?: string;
  session: ClientSession;
  isCurrent?: boolean;
}

export function SessionMeta({ session, isCurrent = false, id }: SessionMetaProps) {
  const { t } = useTranslation();
  const { getCountry, formatTimeAgo } = useSessionFormatters();

  const ip = session.metadata?.ip;
  const country = getCountry(session);
  const timeAgo = isCurrent ? undefined : formatTimeAgo(session.last_used);

  return (
    <span id={id} className="flex flex-col text-sm text-textSecondary">
      {(country.code || ip) && (
        <span>
          <SessionCountry {...country} />
          {country.code && ip && ' · '}
          {ip}
        </span>
      )}

      {timeAgo && <span>{t('sessions_last_active', { time: timeAgo })}</span>}
    </span>
  );
}
